<template>
	<v-layout
		row
		wrap
		justify-center
	>
		<v-flex v-show="items.length > 0" xl8>
			<v-data-iterator
				ref="iterator"
				:items="items"
				:pagination.sync="pagination"
				:search="search"
				:rows-per-page-items="rowsPerPageItems"
				:custom-filter="filterItems"
				:custom-sort="customSort"
				:hide-actions="items.length === 0"
				no-data-text="No outputs available"
				no-results-text="No matching outputs found"
				content-tag="v-layout"
				row
				wrap
			>
				<template v-if="items.length > 0" slot="header">
					<IteratorToolbar
						:sort-by="sortBy"
						:sort-name="sortName"
						:pagination="pagination"
						:initial-view="changeView"
						hide-sort
						@search="search = $event"
						@change-view="changeView = $event"
						@sort="sort"
						@pagination="changeSortDirection"
					/>
					<v-progress-linear
						v-if="loading"
						class="ma-0"
						indeterminate
					/>
				</template>
				<ListAndCard
					slot="item"
					slot-scope="props"
					:image-text="props.item.name"
					:card-type="changeView"
					:loading="props.item.changing"
					:flags="props.item.flags"
					url="emit"
					@url="$emit('show', props.item)"
				>
					<template slot="title">
						<div>
							<h3 class="headline mb-0">{{ props.item.name }}</h3>
							<div v-if="props.item.createdAt">Created: {{ props.item.createdDateString }}</div>
							<div v-if="props.item.updatedAt">Updated: {{ props.item.updatedDateString }}</div>
						</div>
					</template>
					<template slot="actions">
						<v-btn
							ripple
							flat
							:disabled="props.item.changing"
							@click="$emit('show', props.item)"
						>
							Output
						</v-btn>
						<v-spacer v-if="changeView === 0"/>
						<v-menu
							v-if="$userCan('manage_outputs') && !project.isArchived"
							:disabled="props.item.classic"
							top
							left
						>
							<v-btn
								slot="activator"
								:disabled="props.item.classic || props.item.changing"
								small
								icon
							>
								<v-icon>more_vert</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile
									v-if="!(props.item.shared && props.item.projectId !== project.id)"
									@click="$emit('export', props.item)"
								>
									<v-list-tile-title>Export</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="$emit('toggle-shared', props.item)">
									<v-list-tile-title>{{ props.item.shared ? 'Unset as shared' : 'Set as shared' }}</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="$emit('set-default', props.item)">
									<v-list-tile-title>Mark as default</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="$emit('update', props.item)">
									<v-list-tile-title>Update</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="$emit('delete', props.item)">
									<v-list-tile-title class="error--text">Delete</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</template>
				</ListAndCard>
			</v-data-iterator>
		</v-flex>
		<v-flex v-if="items.length === 0" xs12>
			<ContextCard
				icon="arrow_upward"
			>
				<template slot="title">
					Create a New Output to get started.
				</template>
			</ContextCard>
		</v-flex>
	</v-layout>
</template>

<script>
import IteratorMixin from '@/mixins/IteratorMixin';
import IteratorToolbar from '@/components/IteratorToolbar';
import ListAndCard from '@/components/ListAndCard';
import ContextCard from '@/components/ContextCard';

export default {
	components: {
		IteratorToolbar,
		ListAndCard,
		ContextCard,
	},
	mixins: [IteratorMixin],
	props: {
		items: { type: Array, default: null },
		loading: { type: Boolean, default: false },
	},
	data() {
		return {
			pagination: {
				rowsPerPage: 12,
				sortBy: 'name',
				descending: false,
				page: 1,
			},
			fuseOptions: {
				keys: ['name'],
				minMatchCharLength: 2,
				threshold: 0.4,
				shouldSort: true,
			},
			cardStyle: 'cardStyle',
		};
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
	},
};
</script>
